import React from "react";

// Icons  library
import {
  FaHome,
  FaChartLine,
  FaImage,
} from "react-icons/fa";
import {
  MdLock,
  MdPerson,
  MdShoppingCart,
  MdStore,
  MdReceipt,
  MdLocalShipping,
  MdPeople,
  MdInventory,
} from "react-icons/md";
import { BiCategory } from "react-icons/bi";
import {
  TbAlertCircle,
} from "react-icons/tb";
import {FiAlertTriangle } from "react-icons/fi";
import { PiTextAaFill } from "react-icons/pi";

// Auth Import
import SignIn from "views/auth/SignIn";
import VendorSelfRegister from "views/auth/VendorSelfRegister";

// Admin Import
import Dashboard from "views/admin/Dasboard/Dashboard";
import User from "views/admin/userManagement/Uesr";
import Vendors from "views/admin/userManagement/Vendors";
import Product from "views/admin/product/Product";
import EditProduct from "views/admin/product/EditProduct";
import Category from "views/admin/category/Category";
import CreateProduct from "views/admin/product/CreateProduct";
import AllOrders from "views/admin/orders/AllOrders";
import Payments from "views/admin/payments/Payments";
import Banner from "views/admin/content/Banner";
import Title from "views/admin/content/Title";
import AllContacts from "views/admin/support/AllContacts";
import Coupon from "views/admin/coupon/Coupon";
import ReturnOrders from "views/admin/orders/ReturnOrders";
import WebBanner from "views/admin/content/WebBanner";

// Vendor Import 
import VendorInventory from "views/vendor/inventory/VendorInventory";
import StockAlert from "views/vendor/inventory/StockAlert";
import CreateProductByVendor from "views/vendor/product/CreateProductByVendor";
import VendorEditProduct from "views/vendor/product/VendorEdiProduct";
import VendorDashboard from "views/vendor/dashboard/VendorDashboard";
import VendorProduct from "views/vendor/product/VendorProduct";


const routes = [
  // ==================== DASHBOARD ====================
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <FaHome className="h-6 w-6" />,
    component: <Dashboard />,
    showInSidebar: true,
    group: "Dashboard",
  },

  // ==================== PRODUCT MANAGEMENT ====================
  {
    name: "Category",
    layout: "/admin",
    path: "category",
    icon: <BiCategory className="h-6 w-6" />,
    component: <Category />,
    showInSidebar: true,
    group: "Product Management",
  },
  {
    name: "Products",
    layout: "/admin",
    path: "products",
    icon: <MdStore className="h-6 w-6" />,
    showInSidebar: true,
    component: <Product />,
    group: "Product Management",
  },
  {
    name: "Edit Products",
    layout: "/admin",
    path: "product/edit/:productId",
    icon: <MdStore className="h-6 w-6" />,
    component: <EditProduct />,
    showInSidebar: false,
  },

  {
    name: "Create Product",
    layout: "/admin",
    path: "create-product",
    icon: <MdStore className="h-6 w-6" />,
    component: <CreateProduct />,
    showInSidebar: false,
    group: "Product Management",
  },

    // ==================== ORDER MANAGEMENT ====================
  {
    name: "Orders",
    layout: "/admin",
    path: "orders",
    icon: <MdShoppingCart className="h-6 w-6" />,
    component: <AllOrders />,
    showInSidebar: true,
    group: "Order Management",
  },
  {
    name: "Return Orders",
    layout: "/admin",
    path: "shipping",
    icon: <MdLocalShipping className="h-6 w-6" />,
        component: <ReturnOrders />,
    showInSidebar: true,
    group: "Order Management",
  },


  // ==================== COUPON MANAGEMENT ====================
  {
    name: "Coupons",
    layout: "/admin",
    path: "coupons",
    icon: <MdShoppingCart className="h-6 w-6" />,
    component: <Coupon />,
    showInSidebar: true,
    group: "Coupon Management",
  },

  //========================PAYMENT REPORTS======================
   {
    name: "Payment Details",
    layout: "/admin",
    path: "payments-details",
    icon: <MdReceipt className="h-6 w-6" />,
    component: <Payments />,
    showInSidebar: true,
    group: "Payment Reports",
  },

  // ==================== CONTENT MANAGEMENT ====================
  {
    name: "App Banner Upload",
    layout: "/admin",
    path: "Appbanner",
    icon: <FaImage className="h-6 w-6" />,
    component: <Banner />,
    showInSidebar: true,
    group: "Content Management",
  },
  {
    name: "Web Banner Upload",
    layout: "/admin",
    path: "Webbanner",
    icon: <FaImage className="h-6 w-6" />,
    component: <WebBanner />,
    showInSidebar: true,
    group: "Content Management",
  },
  {
    name: "Title Change",
    layout: "/admin",
    path: "title-change",
    icon: <PiTextAaFill className="h-6 w-6" />,
    component: <Title />,
    showInSidebar: true,
    group: "Content Management",
  },

  // ==================== USER MANAGEMENT ====================
  {
    name: "Users",
    layout: "/admin",
    path: "users",
    icon: <MdPerson className="h-6 w-6" />,
    component: <User />,
    showInSidebar: true,
    group: "User Management",
  },
  {
    name: "Vendors",
    layout: "/admin",
    path: "vendors",
    icon: <MdPeople className="h-6 w-6" />,
    component: <Vendors />,
    showInSidebar: true,
    group: "User Management",
  },

  
  // ==================== CUSTOMER SUPPORT ====================
   
  {
    name: "Complaints",
    layout: "/admin",
    path: "complaints",
    icon: <FiAlertTriangle className="h-6 w-6" />,
    component: <AllContacts />,
    showInSidebar: true,
    group: "Support",
  },

 
  // ############################################==================== Vendor ====================#################################################################

  {
    name: "Dashboard",
    layout: "/vendor",
    path: "dashboard",
    icon: <FaHome className="h-6 w-6" />,
    component: <VendorDashboard />,
    showInSidebar: true,
    group: "Dashboard",
  },

  {
    name: "Product",
    layout: "/vendor",
    path: "product",
    icon: <MdStore className="h-6 w-6" />,
    component: <VendorProduct />,
    showInSidebar: true,
    group: "Product Managemrnt",
  },
  {
    name: "Create Product",
    layout: "/vendor",
    path: "create",
    icon: <MdStore className="h-6 w-6" />,
    component: <CreateProductByVendor />,
    showInSidebar: false,
    group: "Product Managemrnt",
  },

  {
    name: "Edit Product",
    layout: "/vendor",
    path: "product/edit/:productId",
    icon: <FaChartLine className="h-6 w-6" />,
    component: <VendorEditProduct />,
    showInSidebar: false,
    group: "Product Management",
  },

  // ==================== INVENTORY ====================
  {
    name: "Inventory",
    layout: "/vendor",
    path: "inventory",
    icon: <MdInventory className="h-6 w-6" />,
    component: <VendorInventory />,
    showInSidebar: true,
    group: "Inventory",
  },
  {
    name: "Stock Alerts",
    layout: "/vendor",
    path: "stock-alerts",
    icon: <TbAlertCircle className="h-6 w-6" />,
    component: <StockAlert />,
    showInSidebar: true,
    group: "Inventory",
  },

  // ###########################################==================== AUTH ====================############################################
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    showInSidebar: true,
  },
  {
    name: "Vendor",
    layout: "/auth",
    path: "vendor-self-register",
    icon: <MdLock className="h-6 w-6" />,
    component: <VendorSelfRegister />,
    showInSidebar: true,
  },
];

export default routes;
